module.exports = __webpack_public_path__ + "img/qx4.40e0d00c.png";